import React, { memo } from 'react';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import addDomainToPath from 'commons/addDomainToPath';

/**
 * Adapter component for New Consumer App (NextJS)
 * Uses Algolia data for immediate rendering without GraphQL calls
 */
const SearchProductCardAdapterNewConsumerApp = memo(({ hit, position }) => {
  const productId = parseInt(hit.product_id || hit.objectID, 10);

  // Use Algolia data for immediate rendering
  const productData = {
    id: productId,
    name: hit.name || '',
    slug: hit.slug || hit.objectID,
    path: hit.url_key || `/products/${hit.slug || hit.objectID}`,
    productFamily: hit.family || '',
    productType: hit.type || '',
    productLabel: 'Trending',
    variantsToShow: [
      {
        id: `${hit.product_id || hit.objectID}-default`,
        image: hit.small_img ? addDomainToPath(hit.small_img) : null,
        price: hit.price ? Math.round(hit.price * 0.6) : 0,
        originalPrice: hit.price || 0,
        path: hit.url_key || `/products/${hit.slug || hit.objectID}`,
        quickship: false,
        isOutOfStock: false,
        sku: hit.serial_number || hit.objectID,
      },
    ],
    variantsTotal: 1,
    position: position || 1,
    layout: 'minimal',
    analyticsComponentName: 'search-product-card',
  };

  return <ProductCardStatic {...productData} />;
});

SearchProductCardAdapterNewConsumerApp.displayName =
  'SearchProductCardAdapterNewConsumerApp';

export default SearchProductCardAdapterNewConsumerApp;
